import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail, ArrowUpRight } from "lucide-react";
import { createSignup } from "../api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await createSignup(email, "footer");
    } catch (_) {
      try {
        const list = JSON.parse(localStorage.getItem("pw_signups") || "[]");
        list.push({ email, at: new Date().toISOString() });
        localStorage.setItem("pw_signups", JSON.stringify(list));
      } catch (_) {}
    }
    setDone(true);
    setEmail("");
  };

  return (
    <footer className="bg-ink text-paper relative grain">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 relative">
        <div className="grid lg:grid-cols-[1.4fr_1fr] gap-16 pb-16 border-b border-paper/15">
          <div>
            <span className="eyebrow text-brass">Stay informed</span>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl mt-4 leading-[1.05] display-balance max-w-xl">
              Be first to know when we launch.
            </h2>
            <p className="text-paper/60 mt-5 max-w-md leading-relaxed">
              Join the early-access list. We will send a single note when the first reviews go live —
              no newsletter unless you ask for one.
            </p>

            {done ? (
              <p className="mt-8 text-brass font-medium">You are on the list. Talk soon.</p>
            ) : (
              <form onSubmit={submit} className="mt-8 flex max-w-md border-b border-paper/30 focus-within:border-brass transition-colors">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  className="flex-1 bg-transparent py-3 text-paper placeholder-paper/40 outline-none"
                />
                <button className="flex items-center gap-1 text-sm font-semibold tracking-wide text-brass hover:gap-2 transition-all">
                  Join <ArrowUpRight className="w-4 h-4" />
                </button>
              </form>
            )}
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <span className="eyebrow text-paper/40">Explore</span>
              <ul className="mt-5 space-y-3 text-sm text-paper/70">
                <li><Link to="/explore" className="hover:text-paper transition-colors">All Places</Link></li>
                <li><Link to="/reviews" className="hover:text-paper transition-colors">Reviews</Link></li>
                <li><Link to="/guide" className="hover:text-paper transition-colors">Guides</Link></li>
                <li><Link to="/videos" className="hover:text-paper transition-colors">Videos</Link></li>
              </ul>
            </div>
            <div>
              <span className="eyebrow text-paper/40">Placeworthy</span>
              <ul className="mt-5 space-y-3 text-sm text-paper/70">
                <li><Link to="/about" className="hover:text-paper transition-colors">Our Method</Link></li>
                <li><Link to="/about" className="hover:text-paper transition-colors">About</Link></li>
                <li>
                  <a href="mailto:placeworthy@gmail.com" className="hover:text-paper transition-colors">Contact</a>
                </li>
                <li><Link to="/admin" className="hover:text-paper transition-colors">Editor Login</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pt-10">
          <div>
            <span className="font-serif text-2xl font-semibold">Placeworthy</span>
            <p className="text-paper/40 text-sm mt-1">The guide to places worth experiencing. · placeworthy.ca</p>
          </div>
          <div className="flex items-center gap-5">
            <a href="https://www.instagram.com/placeworthy.guide" target="_blank" rel="noopener noreferrer" aria-label="Placeworthy on Instagram" className="text-paper/60 hover:text-brass transition-colors"><Instagram className="w-5 h-5" /></a>
            <a href="https://www.youtube.com/@Placeworthy" target="_blank" rel="noopener noreferrer" aria-label="Placeworthy on YouTube" className="text-paper/60 hover:text-brass transition-colors"><Youtube className="w-5 h-5" /></a>
            <a href="mailto:placeworthy@gmail.com" className="text-paper/60 hover:text-brass transition-colors"><Mail className="w-5 h-5" /></a>
          </div>
        </div>
        <p className="text-paper/30 text-xs mt-10">
          © {new Date().getFullYear()} Placeworthy · Independent editorial. No paid placements, ever.
        </p>
      </div>
    </footer>
  );
}
